import {
  ArrowLeft,
  ArrowRight,
  Bell,
  BellOff,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleAlert,
  CircleCheck,
  Clock,
  Cloud,
  Copy,
  Download,
  Eraser,
  Eye,
  EyeOff,
  Files,
  GitCommitHorizontal,
  HandGrab,
  House,
  Info,
  Lasso,
  LoaderCircle,
  LogOut,
  type LucideIcon,
  Mail,
  MapPin,
  Menu,
  MessageSquare,
  Minus,
  MousePointer2,
  MoveDown,
  MoveUp,
  Network,
  Plus,
  RadioOff,
  RefreshCw,
  Save,
  ScrollText,
  Search,
  Settings,
  Share2,
  Snowflake,
  SolarPanel,
  Space,
  SquarePen,
  Sun,
  Trash2,
  TriangleAlert,
  Wifi,
  Wind,
  X,
  Zap,
} from "lucide-react";

export const ICONS = {
  arrowBack: ArrowLeft,
  arrowForward: ArrowRight,
  bell: Bell,
  bellOff: BellOff,
  check: Check,
  chevronDown: ChevronDown,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronUp: ChevronUp,
  circleAlert: CircleAlert,
  circleCheck: CircleCheck,
  clock: Clock,
  close: X,
  cloud: Cloud,
  collapse: Menu,
  commit: GitCommitHorizontal,
  copy: Copy,
  documentation: Files,
  download: Download,
  edit: SquarePen,
  eraser: Eraser,
  eye: Eye,
  eyeOff: EyeOff,
  feedback: MessageSquare,
  handGrab: HandGrab,
  home: House,
  info: Info,
  lasso: Lasso,
  loader: LoaderCircle,
  logout: LogOut,
  logs: ScrollText,
  mail: Mail,
  minus: Minus,
  mousePointer: MousePointer2,
  moveDown: MoveDown,
  moveUp: MoveUp,
  network: Network,
  place: MapPin,
  plants: SolarPanel,
  plus: Plus,
  refresh: RefreshCw,
  save: Save,
  search: Search,
  sensorsOff: RadioOff,
  settings: Settings,
  share: Share2,
  snowflake: Snowflake,
  space: Space,
  sun: Sun,
  trash: Trash2,
  triangleAlert: TriangleAlert,
  wifi: Wifi,
  wind: Wind,
  zap: Zap,
} satisfies Record<string, LucideIcon>;

export type IconV2Name = keyof typeof ICONS;
